











import { Vue, Component, Prop } from 'vue-property-decorator'
import Headline from '@/components/layouts/Headline.vue'
import PairsTable from '@/components/layouts/PairsTable.vue'
import Itemize from '@/components/layouts/Itemize.vue'
import about from '@/assets/data/ja/about.json'

@Component({
  components: {
    Headline,
    Itemize,
    PairsTable
  }
})
export default class About extends Vue {
  private about = about
}
